"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const Avatar = (props) => {
    const { alt, size = "small", src, name, sx, ...rest } = props;
    function renderInitials() {
        if (!name) {
            return alt?.[0] || "";
        }
        const array = name
            // Remove all double spaces
            .replace(/ +(?= )/g, "")
            // Split to array
            .split(" ");
        if (array.length === 1) {
            return array[0][0];
        }
        else {
            return `${array[0][0]}${array[1][0]}`;
        }
    }
    const getStyles = () => {
        switch (size) {
            case "small":
                return { width: "40px", height: "40px", fontSize: "16px" };
            case "medium":
                return { width: "55px", height: "55px", fontSize: "18px" };
            case "large":
                return { width: "70px", height: "70px", fontSize: "20px" };
            default:
                return {};
        }
    };
    return (react_1.default.createElement(material_1.Avatar, { alt: alt, src: src, sx: {
            ...getStyles(),
            backgroundColor: colors_1.default.secondary[700],
            border: `solid 2px ${colors_1.default.secondary[600]}`,
            textTransform: "uppercase",
            ...sx,
        }, ...rest }, renderInitials()));
};
exports.default = Avatar;
